"use client";
import { jsxs as t, jsx as i } from "react/jsx-runtime";
const s = ({
  title: e,
  titleId: r,
  desc: l,
  descId: a,
  ...h
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-cm",
    viewBox: "0 0 640 480",
    "aria-labelledby": r,
    "aria-describedby": a,
    ...h,
    children: [
      l ? /* @__PURE__ */ i("desc", { id: a, children: l }) : null,
      e ? /* @__PURE__ */ i("title", { id: r, children: e }) : null,
      /* @__PURE__ */ i("path", { fill: "#007a5e", d: "M0 0h213.3v480H0z" }),
      /* @__PURE__ */ i("path", { fill: "#ce1126", d: "M213.3 0h213.4v480H213.3z" }),
      /* @__PURE__ */ i("path", { fill: "#fcd116", d: "M426.7 0H640v480H426.7z" }),
      /* @__PURE__ */ t("g", { fill: "#fcd116", transform: "translate(320 240)scale(7.1111)", children: [
        /* @__PURE__ */ t("g", { id: "cm-b", children: [
          /* @__PURE__ */ i("path", { id: "cm-a", d: "M0-8-2.5-.4 1.3.9z" }),
          /* @__PURE__ */ i(
            "use",
            {
              xlinkHref: "#cm-a",
              width: "100%",
              height: "100%",
              transform: "scale(-1 1)"
            }
          )
        ] }),
        /* @__PURE__ */ i(
          "use",
          {
            xlinkHref: "#cm-b",
            width: "100%",
            height: "100%",
            transform: "rotate(72)"
          }
        ),
        /* @__PURE__ */ i(
          "use",
          {
            xlinkHref: "#cm-b",
            width: "100%",
            height: "100%",
            transform: "rotate(144)"
          }
        ),
        /* @__PURE__ */ i(
          "use",
          {
            xlinkHref: "#cm-b",
            width: "100%",
            height: "100%",
            transform: "rotate(-144)"
          }
        ),
        /* @__PURE__ */ i(
          "use",
          {
            xlinkHref: "#cm-b",
            width: "100%",
            height: "100%",
            transform: "rotate(-72)"
          }
        )
      ] })
    ]
  }
);
export {
  s as default
};
